
import { LabelType } from '@/model';
import IconButton from '@/components/IconButton.vue';
import LabelTypeEditorDialog from '@/components/LabelTypeEditorDialog.vue';
import { titleForRoute } from '@/store/ui-config';
import Vue from 'vue';

export default Vue.extend({
  name: 'LabelTypesView',

  components: {
    IconButton,
    LabelTypeEditorDialog,
  },

  props: {
    loading: { type: Boolean, default: false },
    labelTypes: { type: Array as () => LabelType[], default: () => [] },
  },

  data() {
    return {
      showEditor: false,
      editItem: undefined as LabelType | undefined,
      headers: [
        { text: 'Seq No', value: 'sortOrder', width: '100px' },
        { text: 'Name', value: 'code' },
        { text: 'Preview', value: 'preview', sortable: false },
        { text: 'Selectable', value: 'selectable' },
        { text: 'Actions', value: 'actions', sortable: false },
      ],
    };
  },

  computed: {
    sortedTypes(): LabelType[] {
      return [...this.labelTypes].sort((a, b) => (a.sortOrder ?? 999) - (b.sortOrder ?? 999));
    },
  },

  methods: {
    titleForRoute,
    typeColor(labelType: LabelType): string {
      const c = labelType.color;
      return `rgba(${c.r}, ${c.g}, ${c.b}, 1)`;
    },
    newLabelType() {
      this.editItem = undefined;
      this.showEditor = true;
    },
    editLabelType(labelType: LabelType) {
      this.editItem = { ...labelType };
      this.showEditor = true;
    },
    onSaved(labelType: LabelType) {
      this.$emit('saved', labelType);
    },
  },
});
